import { Processor } from '@weave/schema-gen-ts/dist/schemas/payments-platform/payouts/v1';
import { PayoutsAPI, serviceName } from '@frontend/api-payments';
import { useSchemaQuery } from '@frontend/react-query-helpers';

export { useStripePayoutTransactions } from './use-stripe-payout-transactions';

export const useGetPayoutV1Query = ({
  payoutId,
  locationId,
  processor,
  enabled = true,
}: {
  payoutId: string;
  locationId: string;
  processor: Processor;
  enabled?: boolean;
}) => {
  return useSchemaQuery({
    service: PayoutsAPI,
    serviceName,
    endpointName: 'GetLocationPayout',
    request: { payoutId, locationId, processor },
    options: {
      refetchOnWindowFocus: false,
      enabled: enabled && !!payoutId,
    },
  });
};

/**
 * Query hook for Justifi payout transactions.
 */
export const useGetPayoutTransactionsV1Query = ({
  payoutId,
  locationId,
  processor,
}: {
  payoutId: string;
  locationId: string;
  processor: Processor;
}) => {
  return useSchemaQuery({
    service: PayoutsAPI,
    serviceName: `${serviceName}-stripe-legacy`,
    endpointName: 'ListLocationPayoutTransactions',
    request: { locationId, payoutId, processor, includeSummary: true },
    options: {
      refetchOnWindowFocus: false,
      enabled: !!payoutId,
    },
  });
};
